import { Notification, Tooltip } from '@app/components'
import { LogoutOutlined, SettingOutlined, UserOutlined } from '@app/components/icons'
import { ROUTE } from '@app/data'
import { ConfirmationModal } from '@app/generic-collections'
import { IStore } from '@app/redux'
import { auth, errorHandler } from '@app/services'
import { signOut } from 'firebase/auth'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

const Footer = styled.div<{ $collapsed: boolean }>`
  display: flex;
  flex-direction: ${(props) => (props.$collapsed ? 'column' : 'row')};
  align-items: center;
  justify-content: center;
  gap: ${(props) => (props.$collapsed ? '12px' : '28px')};
  flex-shrink: 0;
  margin-top: auto;
  padding: 12px 8px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`

const IconButton = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  color: #d7d7d7;
  cursor: pointer;
  display: inline-flex;
  font-size: 20px;
  height: 36px;
  justify-content: center;
  padding: 0;
  width: 36px;

  .anticon {
    color: inherit;
    font-size: 20px;
  }

  &:hover,
  &:focus-visible {
    color: #fff;
    outline: none;
  }
`

export const SidebarAccountFooter = ({ collapsed }: { collapsed: boolean }) => {
  const { user } = useSelector((state: IStore) => state)
  const router = useRouter()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const currentStep = user.registrationStepNo

  const goTo = (route: string) => {
    if (user.frozen == 'True') {
      router.push('/frozen')
    } else if (currentStep < 4) {
      router.push('/account-registration')
    } else {
      router.push(route)
    }
  }

  const handleLogout = async () => {
    try {
      await signOut(auth)
    } catch (error) {
      Notification({ message: error.message, type: 'error' })
      errorHandler.report`Failed to logout: ${error}`
    }
  }

  const tooltipPlacement = collapsed ? 'right' : 'top'

  return (
    <>
      <Footer $collapsed={collapsed}>
        <Tooltip title="Profile" placement={tooltipPlacement}>
          <span>
            <IconButton type="button" aria-label="Profile" onClick={() => goTo(ROUTE.PROFILE)}>
              <UserOutlined />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title="Settings" placement={tooltipPlacement}>
          <span>
            <IconButton type="button" aria-label="Settings" onClick={() => goTo(ROUTE.SETTINGS)}>
              <SettingOutlined />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title="Log out" placement={tooltipPlacement}>
          <span>
            <IconButton type="button" aria-label="Log out" onClick={() => setIsModalOpen(true)}>
              <LogoutOutlined />
            </IconButton>
          </span>
        </Tooltip>
      </Footer>

      <ConfirmationModal
        onCancel={() => setIsModalOpen(false)}
        onOk={handleLogout}
        open={isModalOpen}
        message={'Are you sure you want to logout'}
        confirmButtonText="Logout"
      />
    </>
  )
}
